import React from 'react';
import { ACCENT, FONT } from '../../lib/tokens';
import { Ic } from '../Icons';

const TITLES = {
  home: 'Home',
  schedule: 'Schedule',
  'parking-lot': 'Parking Lot',
  attendees: 'Attendees',
  logistics: 'Logistics',
  commitments: 'Commitments',
  resources: 'Resources',
  uploads: 'Uploads & Links',
  'post-event': 'Post-Event',
  admin: 'Admin',
};

export const TOPBAR_HEIGHT = 60;

export default function ContentTopBar({ screen, onAITap }) {
  return (
    <div
      style={{
        height: TOPBAR_HEIGHT,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 28px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        background: 'rgba(15,22,40,0.6)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <h1
        style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#fff',
          letterSpacing: '-0.01em',
          fontFamily: FONT,
          margin: 0,
        }}
      >
        {TITLES[screen] || 'ELX Live'}
      </h1>

      <button
        onClick={onAITap}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          background: ACCENT,
          border: 'none',
          borderRadius: 24,
          padding: '9px 16px',
          color: '#fff',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: FONT,
          boxShadow: `0 2px 14px ${ACCENT}55`,
          letterSpacing: '0.01em',
        }}
      >
        <Ic.Spark size={14} color="#fff" />
        Ask ELX AI
      </button>
    </div>
  );
}
